import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-storno-success',
    templateUrl: './storno-success.component.html',
    styleUrls: ['./storno-success.component.scss'],
    standalone: false
})
export class StornoSuccessComponent implements OnInit, AfterViewInit, ModalInterface {
  @ViewChild('StornoSuccess') modalTemplateRef: TemplateRef<any>;
  initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
  modalDialogRef: NxModalRef<any, any>;
  confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

  constructor(
    private dialogService: NxDialogService
  ) { }

  openModal(): void {
    this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true, width: '512px' });
    this.modalDialogRef.beforeClosed().subscribe(() => this.confirm.next(new SubmitEvent('submit')));
  }

  closeModal(): void {
    this.modalDialogRef.close();
  }

  ngAfterViewInit(): void {
    this.initiator.next(true);
  }

  ngOnInit(): void {
  }

  inputData(inputData?: any): void {

  }

}
